<template>
    <div class="full-width-flex">
        <div class="initialPart">
<!--            <el-affix :offset="20" target=".initialPart">-->
                <initialList :initialList="firstLetterList" @clickInitial="clickLetterEvent" />
<!--            </el-affix>-->
        </div>

        <div class="content-part">
            <div v-for="(value, key) in firstLetterObj" :key="key" :ref="setDivRef" :data-id="key">
                <firstLetterTitleBlock :title="key" />

                <holderCard v-for="(v, i) in value" :key="v.id" :card="v" :letterKey="key" @delete-complete="deleteCallback" />
            </div>
        </div>
    </div>
</template>

<script setup>
    import initialList from '@/components/shopopee/common/initialList'
    import firstLetterTitleBlock from '@/components/shopopee/dataDisplay/firstLetterTitleBlock'
    import holderCard from "@/components/shopopee/card/holderCard"
    import myUtil from "@/util/util"
    import {ref, onMounted, watch} from "vue";
    import util from "@/util/util";

    const props = defineProps(["cardList"])

    const firstLetterList = ref([])
    const firstLetterObj = ref({})
    const divRefs = ref({})

    const setDivRef = (el) => {
        if (el) {
            divRefs.value[el.dataset.id] = el // 将每个 div 的引用添加到数组中
        }
    }

    watch(() => props.cardList, (newValue, oldValue) => {
        divRefs.value = []
        generateFirstLetterObj(newValue)
    });

    function generateFirstLetterObj(list){
        firstLetterObj.value = util.getFirstLetterUppercaseObj(list)
        firstLetterList.value = Object.keys(firstLetterObj.value)
    }

    function clickLetterEvent(value, index) {

        if (null != value){
            divRefs.value[value].scrollIntoView()
        }
    }

    function deleteCallback(record1Id, letterKey) {
        if (null != record1Id && null != letterKey){
            const list = firstLetterObj.value[letterKey]
            let index = null

            for (let i=0; i<list.length; i++){
                const v = list[i]

                if (v.record1Id == record1Id){
                    index = i
                    break
                }
            }

            if (null != index){
                list.splice(index, 1)
            }
        }
    }
</script>

<style scoped>
    .full-width-flex {
        width: 100%;
        position: relative;
        display: flex;
    }

    .content-part {
        width: calc(100% - 35px);
        margin-top: 16px;
        margin-bottom: 16px;
    }
</style>